/** @format */

import ApiCollectionResponseInterface from '../api/ApiCollectionResponseInterface';

export const TARIFF_TYPE_MTR = 1;
export const TARIFF_TYPE_HOSTING = 2;

export default interface TariffInterface {
    readonly '@id': string;
    id: number;
    tariffName: string;
}

export interface TariffCollectionInterface extends ApiCollectionResponseInterface {
    'hydra:member': Array<TariffInterface>;
}
